import { render, staticRenderFns } from "./coperjuniperaktarim.vue?vue&type=template&id=580880dd"
import script from "./coperjuniperaktarim.vue?vue&type=script&lang=js"
export * from "./coperjuniperaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports